import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import Description from "../../Components/Description?v=0.0.2";
import HighlightText from "../../Components/HighlightText?v=0.0.2";
import * as Constants from "../../Constants?v=0.0.2";

import DeletePageImage from "../../Images/DeletePageImage.svg";

function AccountDeleteMyPlan(props) {
  document.title = "myPlan | Account Delete";
  const environment = props.environment;
  const history = useHistory();
  const [step, setStep] = useState(1);
  const [token, setToken] = useState("");
  const [cardHeading1, setCardHeading1] = useState("ATTENTION");
  const [buttonText, setButtonText] = useState("DELETE MY ACCOUNT");
  const [notValidMessage, setNotValidMessage] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (
      queryString.parse(window.location.search).token === undefined ||
      queryString.parse(window.location.search).token === ""
    ) {
      history.push("/myPlan/signup");
    }
    setToken(queryString.parse(window.location.search).token);
  }, [history]);

  const nextHandler = () => {
    if (step === 1) {
      setStep((prevState) => {
        return prevState + 1;
      });
      setCardHeading1("Your account has  deleted successfully");
      setButtonText("CREATE NEW ACCOUNT");
    }
  };

  const ContinueToStep2 = (event) => {
    setShowLoader(true);
    fetch(environment.myPlanLoginAppAPI + Constants.deleteUserAccount, {
      method: "POST",
      body: JSON.stringify({
        deleteData: {
          deleteToken: token,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setShowLoader(false);
          if (result.dataStatus.isSuccess) {
            nextHandler();
          } else {
            setNotValidMessage(result.dataStatus.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  return (
    <div className="App col-12 d-flex align-items-center myPlan">
      <div className="container custom-container">
        <div className="row flex-direction-col-reverse content-box m-4 m-lg-0">
          <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-lg-start justify-content-center description-box position-relative">
            <div className="d-flex flex-column margin-interaction-card">
              <div className="font-20-600 text-align-left">Delete Account</div>
              <Description
                className="description"
                text="Try contacting us to overcome your issues"
              ></Description>
              <img src={DeletePageImage} alt="" className="my-3" />
              <div className="padding-top d-block">
                <HighlightText
                  className="grey text-align-left font-12-400 center-on-medium-devices"
                  subClassName="blue underline"
                  text1="Need Help ? We are just a click away"
                  text2=""
                  subText="Contact us"
                  hasHyperLink={true}
                  hyperLink="https://www.zetran.com/contact-us/"
                ></HighlightText>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 d-lg-flex d-block align-items-center">
            <div className="mx-auto mx-lg-0 interaction-card">
              <div className="d-flex flex-wrap justify-content-center pb-lg-3">
                <img
                  src="https://cdn.zetran.com/assets-mybooks/accounts-portal/myPlan_logo_Black.png"
                  alt=""
                  className="logo-image"
                />
              </div>
              <div class="font-20-600 d-lg-none b-block my-3">
                Account Deletion
              </div>
              {step === 1 && (
                <h2 className="heading ED2727 bold text-lg-center mt-3 mt-lg-0">
                  {cardHeading1}
                </h2>
              )}
              {step === 1 && (
                <p className="poppins-14 Color-9C9C9C pt-2 text-left font-18">
                  By Deleting your account, you have no more access to your data
                  in myPlan. Make sure you have backed up your data
                </p>
              )}
              {step === 1 && (
                <div className="d-flex align-items-center justify-content-center my-3">
                  <label className="heading text-center ED2727 caution mx-3 px-0">
                    BACKUP YOUR DATA
                  </label>
                </div>
              )}
              <div className="d-flex flex-wrap justify-content-center">
                <img
                  className={`mail-box-logo${step === 2 ? " mt-5" : ""} `}
                  alt=""
                  src="https://cdn.zetran.com/assets-mybooks/accounts-portal/DeleteIcon.png"
                ></img>
              </div>
              {step === 2 && (
                <h2 className="heading mt-5 ED2727 bold text-lg-center">
                  {cardHeading1}
                </h2>
              )}
              <button
                className="button d-flex flex-wrap align-items-center justify-content-center mt-5"
                onClick={
                  step === 1
                    ? ContinueToStep2
                    : () => {
                        history.push("/myPlan/signup");
                      }
                }
              >
                {!showLoader && (
                  <>
                    <div className="mr-2">{buttonText}</div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Outline"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path
                        fill="#fff"
                        d="M18,12h0a2,2,0,0,0-.59-1.4l-4.29-4.3a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15,11H5a1,1,0,0,0,0,2H15l-3.29,3.29a1,1,0,0,0,1.41,1.42l4.29-4.3A2,2,0,0,0,18,12Z"
                      />
                    </svg>
                  </>
                )}
                {showLoader && (
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="spinner-border" role="status"></div>
                    <div className="mx-4">
                      Please Wait... It may take a while
                    </div>
                  </div>
                )}
              </button>
              {step === 1 && notValidMessage.length !== 0 && (
                <label className={`result-label mt-1`}>{notValidMessage}</label>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountDeleteMyPlan;
